import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { VatRateItem, VatRatePLSymbol } from './vat-rate-item';

export class VatRateForPurchaseQuery extends Query<VatRateItem[]> { }

interface VatRateFormPurchaseInternalItem {
    readonly communityTransactions: Readonly<number[]>;
    readonly version: string;
    readonly untaxed: boolean;
    readonly translateKeyName: string;
    readonly translateKeySymbol: string;
    readonly symbol: VatRatePLSymbol | string;
    readonly order: number;
    readonly rate: number;
    readonly id: number;
    readonly externalId: string;
    readonly exempt: boolean;
    readonly default: boolean;
    readonly name: string;
    readonly countryId: number;
    readonly active: boolean;
}

export class VatRateForPurchaseQueryHandlerBase implements QueryHandler<VatRateForPurchaseQuery, VatRateItem[]> {
    public static Url = TaggedUrl.join('purchase/vatRates', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: VatRateForPurchaseQuery): Promise<VatRateItem[]> {
        const { data } = await this.http.get<{ items: VatRateFormPurchaseInternalItem[] }>(VatRateForPurchaseQueryHandlerBase.Url);
        return data.items.map(i => ({
            id: i.id,
            default: i.default,
            exempt: i.exempt,
            communityTransactions: i.communityTransactions,
            name: i.name,
            order: i.order,
            rate: i.rate,
            symbol: i.symbol,
            untaxed: i.untaxed,
            countryId: i.countryId,
            externalId: i.externalId,
            active: i.active
        }));
    }
}
